<template>
  <Modal @close="close">
    <div slot="modal-header">
      <span> {{ $t('pages.details') }} </span>
    </div>
    <ProductView :product-id="productId" :show-back="false" :show-cart="false" />
    <div slot="modal-footer">
      <el-button @click="close">
        {{ $t('general.close') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import ProductView from '../../views/products/ProductView';
export default {
  name: 'DetailProductModal',
  components: { ProductView, Modal },
  props: {
    productId: [Number, String],
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped></style>
